import { OfferListDTO } from '../../../core/domain/offerDocument.dto'

export const offerDocumentViewMapper = (offer: OfferListDTO) => {
  return {
    id: offer.id,
    offerNumber: offer.offerNumber,
    company: offer.customerLead.company,
    firstName: offer.customerLead.firstName,
    lastName: offer.customerLead.lastName,
    email: offer.customerLead.email,
    phone: offer.customerLead.phone,

    price: offer.price,
    pricingDate: offer.pricingDate,
    creationOfferDate: offer.creationOfferDate,
    validityStartDate: offer.validityStartDate,
    contractingDate: offer.contractingDate,
  }
}
